export default __webpack_public_path__ + "static/media/email.3ff45b85.svg";